import { Component, Inject, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { OpenRouteController } from '@shared/src/controllers/open/open.route.controller';
import { ShipmentController } from '@shared/src/controllers/route/shipment/shipment.controller';
import { SecurityController } from '@shared/src/controllers/security/security.controller';
import { HLong } from '@shared/src/datatypes/HLong';
import { ShipmentCardInRouteDto } from '@shared/src/dtos/shipment/ShipmentCardInRouteDto';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { OrderShipmentInRouteDto, OrderShipmentsInRouteDto } from '@shared/src/dtos/shipment/OrderShipmentsInRouteDto';
import { OptionsStripDto } from '@shared/src/dtos/maintenance/option/OptionsStripDto';
import { OptionDto } from '@shared/src/dtos/maintenance/option/OptionDto';

@Component({
    selector: 'shared-route-shipment-order',
    templateUrl: './shared.route.shipment.order.component.html',
    styleUrls: ['./shared.route.shipment.order.component.scss']
})
export class SharedRouteShipmentOrderComponent implements OnInit {
        
    constructor(public openRouteController: OpenRouteController, @Inject('HomeController') public homeController: HomeController,
        @Inject('SecurityController') public securityController: SecurityController, private shipmentController: ShipmentController) {
        this.securityController.getStoredUserDto().subscribe(data => {
            this.readonly = data.isReadOnly;
        });

    }

    @Output()
    public valueChange: EventEmitter<boolean> = new EventEmitter();
    
    @Input()
    public readonly: boolean = false;

    @Input()
    public onlyvieworder: boolean = false;

    public _routeId: number;
    @Input()
    set routeId(value: number) {
        if (this._routeId === value)
            return;

        this._routeId = value;

        this.loadData();
    }
    get routeId(): number {
        return this._routeId;
    }

  
    ngOnInit() {
            this.loadOptionsOrder();   
    }

    public optionsOrder: OptionsStripDto;
    public actualOptionOrderId: string = "PACKAGE";
    public loadOptionsOrder() {

        let result = new OptionsStripDto();
        result.add(OptionDto.build("ORDERLOAD", "SHARED.ROUTE.SHIPMENT.OPCIONS.ORDERLOAD.CAPTION", "SHARED.ROUTE.SHIPMENT.OPCIONS.ORDERLOAD.HELP", "", 1, -1, 1, true, false));
        result.add(OptionDto.build("ORDERUNLOAD", "SHARED.ROUTE.SHIPMENT.OPCIONS.ORDERUNLOAD.CAPTION", "SHARED.ROUTE.SHIPMENT.OPCIONS.ORDERUNLOAD.HELP", "", 2, -1, 1, false, false));
        this.actualOptionOrderId = result.getActualSelected().optionId;
        this.optionsOrder = result;
    }

    onClickOptionOrder(option: OptionDto) {
        this.actualOptionOrderId = option.optionId;
        
    }

    getOrder(){

        if(this.actualOptionOrderId == 'ORDERUNLOAD')
            return '-orderInRoute';

        return 'orderInRoute';
    }

    drop(event: CdkDragDrop<ShipmentCardInRouteDto>) {
        moveItemInArray(this.shipmentsInRoute, event.previousIndex, event.currentIndex);

        let shipmentInRouteNewOrden: Array<OrderShipmentInRouteDto>;

        if(this.actualOptionOrderId == 'ORDERLOAD'){
            shipmentInRouteNewOrden = this.shipmentsInRoute.map((item, index) => ({
                routeId: this.routeId,
                shipmentId: item.shipmentId,
                orderInRoute: index
            }));
        }else{
            shipmentInRouteNewOrden = this.shipmentsInRoute.slice().reverse().map((item, index) => ({
                routeId: this.routeId,
                shipmentId: item.shipmentId,
                orderInRoute: index
            }));
        }

        let shipmentsInRouteNewOrden: OrderShipmentsInRouteDto = OrderShipmentsInRouteDto.build(this.routeId, shipmentInRouteNewOrden);

        this.shipmentController.aplicarOrdreShipmentInRoute(shipmentsInRouteNewOrden).subscribe(e => {
            this.loadData();
            if (e){
                this.valueChange.next(true);
            }
        });
    }


    public showvieworder: boolean;
    public shipmentsInRoute: ShipmentCardInRouteDto[];

    public loadData(){

        if(HLong.isNullOrNullLong(this.routeId)){
            this.shipmentsInRoute = new Array();  
            return;
        }

        this.shipmentController.getShipmentsInRouteByRouteId(this.routeId).subscribe(data => {
            if(data)
                this.shipmentsInRoute = data;
            else
                this.shipmentsInRoute = new Array();    
            
        });

    }

    public selectedShipment: ShipmentCardInRouteDto = null;

    selectShipment(shipment: ShipmentCardInRouteDto) {
        this.selectedShipment = shipment;
    }


    moveShipmentUp(value: ShipmentCardInRouteDto) {
        if (!value)
            return;

        //Si estem veien la vista de descarrega, l'acció serà l'inversa
        if(this.actualOptionOrderId == 'ORDERUNLOAD'){
            this.internalMoveShipmentDown(value);
            return;
        }
        
        this.internalMoveShipmentUp(value);
    }
    
    internalMoveShipmentUp(value: ShipmentCardInRouteDto) {
        if (!value)
            return;

        this.shipmentController.pujarShipmentInRoute(this.routeId, value.shipmentId).subscribe(e => {
            if (e){
                this.loadData();
                this.valueChange.next(true);
            }
        });
    }
    
    moveShipmentDown(value: ShipmentCardInRouteDto) {
        if (!value)
            return;

        //Si estem veien la vista de descarrega, l'acció serà l'inversa
        if(this.actualOptionOrderId == 'ORDERUNLOAD'){
            this.internalMoveShipmentUp(value);
            return;
        }

        this.internalMoveShipmentDown(value);
    }
   
    internalMoveShipmentDown(value: ShipmentCardInRouteDto) {
        if (!value)
            return;

        this.shipmentController.baixarShipmentInRoute(this.routeId, value.shipmentId).subscribe(e => {
            if (e){
                this.loadData();
                this.valueChange.next(true);
            }
        });
    }
}
